import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Background } from "../../Background/Background";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Image } from "../../Image/Image/Image";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { PromotionBannerSlice } from "../PromotionBannerSlice/PromotionBannerSlice";
import { Text } from "../../Text/Text/Text";
import styles from "./ImmersiveMastheadSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var immersiveMastheadEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3', 'bodycopyLarge', 'bodycopyExtraLarge'];
export var immersiveMastheadBodyTypogs = ['subhead1', 'subhead2', 'subhead3', 'bodycopySmall', 'bodycopy', 'bodycopyLarge', 'bodycopyExtraLarge', 'caption', 'captionSmall'];
export var immersiveMastheadHorizAlign = ['left', 'center'];
export var immersiveMastheadVertAlign = ['top', 'center'];
export var ImmersiveMastheadSlice = function ImmersiveMastheadSlice(_ref) {
  var _offerBanner$text, _offerBanner$popup, _promoBanner$cta, _promoBanner$cta2;
  var background = _ref.background,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'eyebrow1'
    } : _ref$eyebrow,
    graphic = _ref.graphic,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? {
      text: '',
      typog: 'bodycopy'
    } : _ref$headline,
    horizAlign = _ref.horizAlign,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? {
      text: '',
      typog: 'bodycopy'
    } : _ref$body,
    _ref$noteLeft = _ref.noteLeft,
    noteLeft = _ref$noteLeft === void 0 ? '' : _ref$noteLeft,
    _ref$noteRight = _ref.noteRight,
    noteRight = _ref$noteRight === void 0 ? '' : _ref$noteRight,
    _ref$offerBanner = _ref.offerBanner,
    offerBanner = _ref$offerBanner === void 0 ? {
      text: {
        typog: 'bodycopy',
        text: '',
        className: ''
      }
    } : _ref$offerBanner,
    promoBanner = _ref.promoBanner,
    _ref$vertAlign = _ref.vertAlign,
    vertAlign = _ref$vertAlign === void 0 ? 'top' : _ref$vertAlign;
  var renderGraphic = function renderGraphic(width) {
    width = width || '';
    if (graphic) {
      return /*#__PURE__*/_jsx(Image, {
        src: graphic.image1x,
        srcTwoX: graphic.image2x,
        alt: graphic.alt,
        className: styles.mastheadGraphic,
        loading: graphic.loading || 'eager',
        width: width || undefined,
        transformations: {
          image1x: {
            width: parseInt(width, 10) || undefined
          },
          image2x: {
            width: parseInt(width, 10) * 2 || undefined
          }
        },
        forceTwoXInSrc: true
      });
    }
  };
  var hasOfferBanner = (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text = offerBanner.text) === null || _offerBanner$text === void 0 ? void 0 : _offerBanner$text.text) || (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title);

  // @TODO Make D8 script to repair and then remove
  if (eyebrow && !eyebrow.typog) {
    eyebrow.typog = 'bodycopyExtraLarge';
  }
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    className: styles.mastheadBackgroundImage,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.masthead,
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx("div", {
          className: horizAlign === 'left' ? styles.mastheadContentWrapperHorizAlignLeft : styles.mastheadContentWrapper,
          children: /*#__PURE__*/_jsxs("div", {
            className: classnames({
              [styles.mastheadContent]: horizAlign === 'center',
              [styles.mastheadContentHorizAlignLeft]: horizAlign === 'left',
              [styles.mastheadContentNoGraphic]: (graphic === null || graphic === void 0 ? void 0 : graphic.image1x) === ''
            }),
            children: [/*#__PURE__*/_jsx("div", {
              className: classnames(styles.mastheadMainContentWrapper, {
                [styles["mastheadMainContentWrapperVerticalAlign".concat(_capitalize(vertAlign))]]: true,
                [styles.mastheadMainContentWrapperHorizAlignLeft]: horizAlign === 'left'
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: horizAlign === 'center' ? styles.mastheadMainContent : styles.mastheadMainContentHorizAlignLeft,
                children: [(graphic === null || graphic === void 0 ? void 0 : graphic.image1x) && /*#__PURE__*/_jsxs(Breakpoint, {
                  breakpoint: "small",
                  children: [renderGraphic(graphic.widthMobile), renderGraphic(graphic.widthDesktop)]
                }), (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && /*#__PURE__*/_jsx(Text, {
                  className: styles.mastheadEyebrow,
                  typog: eyebrow.typog,
                  children: eyebrow.text
                }), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(HeadingText, {
                  className: horizAlign === 'center' ? styles.mastheadHeadline : styles.mastheadHeadlineHorizAlignLeft,
                  ariaLevel: 1,
                  typog: headline.typog,
                  children: headline.text
                }), (body === null || body === void 0 ? void 0 : body.text) && /*#__PURE__*/_jsx(Text, {
                  className: styles.mastheadBody,
                  richText: true,
                  typog: body.typog,
                  children: body.text
                }), hasOfferBanner && /*#__PURE__*/_jsx(OfferBanner, _objectSpread({
                  className: styles.mastheadOfferBanner
                }, offerBanner))]
              })
            }), (noteLeft || noteRight) && /*#__PURE__*/_jsx("div", {
              className: horizAlign === 'center' ? styles.mastheadSubContent : styles.mastheadSubContentHorizAlignLeft,
              children: /*#__PURE__*/_jsxs("div", {
                className: horizAlign === 'center' ? styles.mastheadNote : styles.mastheadNoteHorizAlignLeft,
                children: [horizAlign === 'center' && /*#__PURE__*/_jsx(Text, {
                  className: horizAlign === 'center' ? styles.mastheadNoteLeft : undefined,
                  typog: "bodycopySmall",
                  children: noteLeft
                }), /*#__PURE__*/_jsx(Text, {
                  className: horizAlign === 'center' ? styles.mastheadNoteRight : styles.mastheadNoteRightHorizAlignLeft,
                  typog: "bodycopySmall",
                  children: noteRight
                })]
              })
            })]
          })
        }), (promoBanner === null || promoBanner === void 0 ? void 0 : (_promoBanner$cta = promoBanner.cta) === null || _promoBanner$cta === void 0 ? void 0 : _promoBanner$cta.text) !== '' && (promoBanner === null || promoBanner === void 0 ? void 0 : (_promoBanner$cta2 = promoBanner.cta) === null || _promoBanner$cta2 === void 0 ? void 0 : _promoBanner$cta2.url) !== '' && /*#__PURE__*/_jsx("div", {
          className: styles.mastheadPromoBanner,
          children: /*#__PURE__*/_jsx(PromotionBannerSlice, _objectSpread({
            className: styles.mastheadPromoBannerInner
          }, promoBanner))
        })]
      })
    })
  }));
};